import { StringOrUndefined, TimeType } from 'store/entity/types';
import { truncateString } from '../../../components/TaskPreferences/Messages';
import { convertDigitToProperFormat } from '../../../utils/number';
import i18n from '../../../i18n';
import { addDash } from './PrintSingleTask/PrintParts/Messages';

export default {
  AskYourManager: 'لطفاً از مدیر خود بخواهید تا دعوت‌نامه‌ای برای شما بفرستد.',
  create: 'ساختن',
  archived: 'نمایش بایگانی شده‌ها',
  order: 'ترتیب بر اساس',
  creationDate: 'تاریخ ایجاد',
  updateDate: 'تاریخ به‌روزرسانی',
  dueDate: 'مهلت انجام',
  creationDate_asc: 'قدیمی‌ترین',
  creationDate_desc: 'جدید ترین',
  updateDate_asc: 'قدیمی‌ترین',
  updateDate_desc: 'جدید ترین',
  dueDate_asc: 'نزدیکترین مهلت',
  dueDate_desc: 'دیرترین مهلت',
  startDate_asc: 'نزدیکترین شروع',
  startDate_desc: 'دیرترین شروع',
  persons: 'نفر',
  setTime: 'ثبت',
  operationDone: 'عملیات با موفقیت انجام شد',
  taskWeight: 'وزن',
  autoFill: 'تکمیل خودکار',
  noMatchFound: 'موردی یافت نشد',
  calendar: 'تقویم',
  today: 'امروز',
  month: 'ماه',
  week: 'هفته',
  next: '',
  back: 'قبلی',
  list: 'لیست',
  allDay: 'کل روز',
  showDeleted: 'نمایش حذف شده‌ها',
  deleted: 'حذف شده',
  other: '(سایر موارد)',
  allTasks: 'تمام وظیفه‌‌ها',
  editNotAllowed: 'دسترسی ویرایش ندارید',
  changesWillBeLost: 'تغییرات شما هنوز ذخیره نشده است. ایا مطمئن هستید؟',
  dropHere: 'فایل را در این محدوده رها کنید.',
  createNewTask: 'تسک جدیدی بسازید',
  cancel: 'لغو',
  submitAsDraft: 'ثبت به صورت پیشنویس',
  save: 'ذخیره',
  saveDraft: 'ذخیره پیشنویس',
  saveProgress: 'ذخیره پیشرفت',
  saveAndCreateNew: 'ذخیره و ساخت مشابه',
  taskTitle: 'عنوان',
  description: 'توضیحات',
  showCreator: 'نمایش سازنده',

  printWholeTasks(title: string) {
    return i18n.t('printWholeTasks', {
      ns: 'taskManager',
      title: title,
    });
  },
  printTasks(title: string) {
    return i18n.t('printTasks', { ns: 'taskManager', title: title });
  },
  noTaskCanBeCreated: 'امکان ساخت هیج قالبی در این پروژه فعال نشده است',
  noTaskFoundPleaseCheckFilters1:
    'موردی یافت نشد، لطفا از درست بودن فیلتر‌های اعمال شده در بالا (مانند فیلتر سال) و یا پروژه انتخاب شده مطمئن شوید، همچنین ممکن است موارد مربوطه بایگانی شده باشد که می‌توانید از طریق دکمه ',
  noTaskFoundPleaseCheckFilters2: ' مشاهده آن‌ها را فعال کنید.',
  dueDateInFuture: 'مصوبات با سررسید در آینده',
  hideParents: 'بستن',
  pleaseSelectAProject: 'لطفا پروژه ای را انتخاب کنید',
  findATask: 'جستجوی وظیفه',
  smsSent: 'پیامک ارسال شد',
  lockTask: 'پس از ذخیره قفل شود',
  fillRequiredFields(act: string) {
    return i18n.t('fillRequiredFields', { ns: 'taskManager', act });
  },
  year: 'سال',
  yearFilter: 'فیلتر سال',
  filterAssignee: 'فیلتر مجری',
  undraftTask(undraftTitle: string | undefined, taskName: string | undefined) {
    if (undraftTitle) return undraftTitle;
    else return i18n.t('notifyTask', { ns: 'taskManager', taskName });
  },
  undraftTaskAndSubtask(
    undraftTitle: string | undefined,
    taskName: string | undefined,
    subtasksTitle: string | undefined
  ) {
    let taskNameAlternative: string = '';
    let subTasksTitleAlternative: string = '';
    if (undraftTitle) return undraftTitle;
    if (!taskName) taskNameAlternative = i18n.t('task', { ns: 'taskManager' });
    if (!subtasksTitle)
      subTasksTitleAlternative = i18n.t('steps', { ns: 'taskManager' });
    return i18n.t('undraftTaskAndSubtask', {
      ns: 'taskManager',
      taskName: taskName || taskNameAlternative,
      subtasksTitle: subtasksTitle || subTasksTitleAlternative,
    });
  },

  taskTemplateName(templateName: string) {
    return `عنوان ${templateName}`;
  },
  saveAndReadyToPublishTask(
    readyToPublishTaskTitle: StringOrUndefined,
    taskName: string
  ) {
    return `ذخیره و ${this.readyPublishTask(
      readyToPublishTaskTitle,
      taskName
    )}`;
  },
  saveAndReadyToPublishSubTask(
    readyToPublishSubTaskTitle: StringOrUndefined,
    subTasksTitle: StringOrUndefined
  ) {
    return `ذخیره و ${this.readyPublishSubTask(
      readyToPublishSubTaskTitle,
      subTasksTitle
    )}`;
  },
  orderBy(type?: 'creationDate' | 'updateDate' | 'dueDate') {
    const msg = 'مرتب شده بر اساس: ';
    switch (type) {
      case 'creationDate':
        return msg + this.creationDate;
      case 'updateDate':
        return msg + this.updateDate;
      case 'dueDate':
        return msg + this.dueDate;
      default:
        return 'مرتب نشده!';
    }
  },
  parentTaskTitle(templateName: string, taskName: string) {
    return `[${templateName}] ${taskName}`;
  },
  taskIsDraft(taskName: string) {
    return i18n.t('taskIsDraft', { ns: 'taskManager', taskName });
  },
  taskHasDraftSubtask(taskName: string, subTaskTitle: string) {
    return i18n.t('taskHasDraftSubtask', {
      ns: 'taskManager',
      taskName,
      subtask: this.subtasks(subTaskTitle),
    });
  },
  assignee(customTitle: StringOrUndefined) {
    if (customTitle) {
      return customTitle;
    }
    return i18n.t('assignees', { ns: 'taskManager' });
  },
  followers(customTitle: StringOrUndefined) {
    if (customTitle) {
      return customTitle;
    }
    return i18n.t('follower', { ns: 'taskManager' });
  },
  verifier(verifierTitle: StringOrUndefined) {
    if (verifierTitle) {
      return verifierTitle;
    }
    return i18n.t('conformers', { ns: 'taskManager' });
  },
  taskPublisher(taskPublisher: StringOrUndefined) {
    if (taskPublisher) {
      return taskPublisher;
    }
    return i18n.t('publishers', { ns: 'taskManager' });
  },
  subTaskPublisher(subTaskPublisher: StringOrUndefined) {
    if (subTaskPublisher) {
      return subTaskPublisher;
    }
    return i18n.t('subtasksPublishers', { ns: 'taskManager' });
  },
  readyPublishTaskBy(
    readyPublishTaskTitle: StringOrUndefined,
    taskName: string,
    by: string,
    subTaskPublisherTitle: string
  ) {
    if (!by) {
      return i18n.t('declareSubtaskPublisherTitle', {
        ns: 'taskManager',
        declareSubtaskPublisherTitle: subTaskPublisherTitle,
      });
    }
    return (
      this.readyPublishTask(readyPublishTaskTitle, taskName) +
      ' توسط ' +
      (by || '')
    );
  },
  readyPublishTask(readyPublishTaskTitle: StringOrUndefined, taskName: string) {
    if (readyPublishTaskTitle) {
      return readyPublishTaskTitle;
    }
    return (
      (i18n.t('readyPublishTask', {
        ns: 'taskManager',
      }) as string) + taskName
    );
  },
  readyPublishSubTaskBy(
    readyPublishSubTaskTitle: StringOrUndefined,
    subtasksTitle: StringOrUndefined,
    by: string,
    subTaskPublisherTitle: string
  ) {
    if (!by) {
      return i18n.t('declareSubtaskPublisherTitle', {
        ns: 'taskManager',
        declareSubtaskPublisherTitle: subTaskPublisherTitle,
      });
    }
    return (
      ((this.readyPublishSubTask(readyPublishSubTaskTitle, subtasksTitle) +
        i18n.t('by', {
          ns: 'taskManager',
        })) as string) + (by || '')
    );
  },
  readyPublishSubTask(
    readyPublishSubTaskTitle: StringOrUndefined,
    subtasksTitle: StringOrUndefined
  ) {
    if (readyPublishSubTaskTitle) {
      return readyPublishSubTaskTitle;
    }
    return (
      i18n.t('readyToPublish', { ns: 'taskManager' }) +
      this.subtasks(subtasksTitle)
    );
  },
  project: 'پروژه',
  template: 'قالب',
  startDate: 'تاریخ شروع',
  verifyDate: 'تاریخ تأیید',
  chooseAProject: 'پروژه‌ای انتخاب کنید',
  chooseATemplate: 'قالبی انتخاب کنید',
  title: 'عنوان',
  taskCreated: 'وظیفه ساخته شد',
  taskUpdated: 'وظیفه با موفقیت به‌روزرسانی شد',
  sortType: 'ترتیب',
  ascending: 'صعودی',
  descending: 'نزولی',
  draftTask: 'تغییر به پیشنویس',
  deleteTask(taskName: string) {
    return `حذف ${taskName}`;
  },
  taskDeleted(taskName: string) {
    return i18n.t('taskDeleted', { ns: 'taskManager', taskName });
  },
  confirmDeleteATask(taskTitle: string, subTasksTitle?: string) {
    const subTasksCustomTitle = subTasksTitle ? subTasksTitle : 'گام‌های';
    return `آیا از حذف «${truncateString(
      taskTitle,
      50
    )}» و تمام ${subTasksCustomTitle} آن مطمئن هستید؟`;
  },
  confirmRestoreTask(taskTitle: string, subTasksTitle?: string) {
    const subTasksCustomTitle = subTasksTitle ? subTasksTitle : 'گام‌های';
    return `آیا از بازگردانی «${truncateString(
      taskTitle,
      50
    )}» و تمام ${subTasksCustomTitle} آن مطمئن هستید؟`;
  },
  taskUndeleted(taskName: string) {
    return i18n.t('taskUndeleted', { ns: 'taskManager', taskName });
  },
  undeleteTask(taskName: string) {
    return `بازگردانی ${taskName}`;
  },
  taskArchived(taskName: string) {
    return i18n.t('taskArchived', { ns: 'taskManager', taskName });
  },
  taskRestored(taskName: string) {
    return i18n.t('taskRestored', { ns: 'taskManager', taskName });
  },
  myTasksList(type: 'project' | 'company', name: string) {
    const msg = 'فهرست وظایف';
    if (type === 'project') {
      return `${msg} پروژهٔ «${name}»`;
    } else if (type === 'company') {
      return `${msg} شرکت «${name}»`;
    }
    return msg;
  },
  subtaskFor(parentTaskName: string, taskName: string) {
    return `${taskName} برای «${parentTaskName}»`;
  },
  thereIsNoSubtask(customTitle?: string) {
    if (customTitle) {
      return `هنوز ${customTitle} برای این وظیفه وجود ندارد`;
    }
    return 'هنوز گامی برای این وظیفه وجود ندارد';
  },
  addASubtask(customTitle?: string) {
    if (customTitle) {
      return `افزودن ${customTitle}`;
    }
    return 'افزودن گام';
  },
  subtasks(customTitle: StringOrUndefined) {
    if (customTitle) {
      return customTitle;
    }
    return i18n.t('steps', { ns: 'taskManager' });
  },
  conversation(customTitle: StringOrUndefined) {
    if (customTitle) {
      return customTitle;
    }
    return i18n.t('conversation', { ns: 'taskManager' });
  },
  verify: 'وضعیت تأیید',
  totalProgress: 'پیشرفت کار مجموع افراد',
  done: 'وضعیت انجام',
  creator: 'سازنده',
  searchTask: 'جستجوی وظیفه',
  close: 'بستن',
  attachments: 'ضمیمه‌ها',
  thereIsNoAttachmentsYet: 'هنوز ضمیمه‌ای وجود ندارد!',
  chooseAnOption: 'گزینه‌ای انتخاب کنید',
  removedUser(userId: number) {
    return `کاربر حذف شده (${userId})`;
  },
  whichTasks(msg?: 'all' | 'createdByMe' | 'assignedToMe') {
    switch (msg) {
      case 'all':
        return 'همه';
      case 'createdByMe':
        return 'ساخت من';
      case 'assignedToMe':
        return 'محول به من';
      default:
        return 'کدام وظایف';
    }
  },
  all: 'همه',
  assignedToMe: 'محول به من',
  createdByMe: 'ساخت من',
  basedOnTemplate: 'بر اساس قالب',
  basedOnStatus: 'بر اساس وضعیت',
  addReminder: 'افزودن یادآور',
  for: 'برای',
  basedOn: 'بر اساس',
  follower: 'مطلع',
  whoToRemind: 'یادآوری برای چه کسی',
  basedOnWhichTime: 'یادآوری بر اساس چه زمانی',
  remove: 'حذف',
  tryAgain: 'تلاش دوباره',
  createTask: 'ساخت وظیفه',
  complete: 'انجام شده',
  incomplete: 'در حال انجام یا انجام نشده ( ناتمام )',
  started: 'در حال انجام',
  notStarted: 'شروع نشده',
  totalTasks: 'مجموع',
  rejected: 'رد شده',
  aTaskCannotBeChildOfItself: 'یک وظیفه نمی‌تواند گامی برای خودش باشد',
  withoutParent: 'بدون مکان',
  report: 'گزارش',
  tasksList: 'فهرست وظایف',
  options: 'گزینه‌ها',
  taskChanged:
    'وضعیت وظیفه‌ی شما تغییر کرده است. لطفاً تغییرات را ذخیره نمایید.',
  printWillStartAutomatically:
    'چاپ گزارش به صورت خودکار شروع خواهد شد. در صورت عدم شروع خودکار دکمه‌های Ctrl و P را فشار دهید.',
  rowNumber: 'ردیف',
  progressValue: 'میزان پیشرفت',
  type: 'نوع',
  dateOfPrint: 'تاریخ تهیه‌ی گزارش',
  tasks: 'وظیفه‌ها',
  newTask: 'وظیفه‌ی جدید',
  checkThatYouHaveSelectedProject: 'مطمئن شوید که پروژه‌ای انتخاب کرده‌اید',
  task: 'وظیفه',
  showSubTasks: 'نمایش گام‌ها',
  averageOfProgress(title: string) {
    if (title) {
      return `میانگین ${title}`;
    }
    return 'میانگین پیشرفت';
  },
  tasksOf(title: string) {
    return `وظیفه‌های «${title}»`;
  },
  dateModalDate: (dateType: TimeType | 'none') => {
    switch (dateType) {
      case 'dueDate':
        return 'مهلت انجام';
      case 'startDate':
        return 'تاریخ شروع';
      case 'verifyDate':
        return 'تاریخ تایید';
      default:
        return 'تاریخ';
    }
  },
  withoutDate: 'بدون تاریخ',
  removeDate: 'حذف تاریخ',
  categorized: 'دسته‌بندی شده',
  projectName: 'بخش/پروژه',
  status: 'وضعیت',
  printIconTitle: 'چاپ وظیفه‌ها',
  reportIconTitle: 'گزارش‌گیری',
  sortIconTitle: 'مرتب‌سازی',
  showIconTitle: 'نمایش پیشرفت',
  copyTaskList: 'کپی لیست',
  hideIconTitle: 'مخفی کردن پیشرفت',
  taskListCopied: 'کپی شد',
  tasksListIconTitle: 'لیست وظیفه‌ها',
  showWeightTitle: 'نمایش وزن',
  hideWeightTitle: 'مخفی کردن وزن',
  fromToDate(start: string | number, end: string | number) {
    if (i18n.language === 'fa') {
      return `از ${start} تا ${end}`;
    } else {
      return `from ${start} to ${end}`;
    }
  },
  userTasks(userName: string) {
    if (i18n.language === 'fa') {
      return `Done by ${userName}`;
    } else {
      return `انجام‌دهنده: «${userName}»`;
    }
  },
  assigneeStatus(status: string) {
    return `${getStatus[status]}`;
  },
  progress(progress: string | number) {
    if (i18n.language === 'fa') {
      return `(${progress} درصد)`;
    } else {
      return `${progress} percent`;
    }
  },
  setAllAsA: (title?: string) =>
    i18n.t('setAllAsA', {
      ns: 'taskManager',
      title: title || i18n.t('all', { ns: 'taskManager' }),
    }),
  taskDrafted(taskName: string) {
    return i18n.t('taskDraft', { ns: 'taskManager', taskName });
  },
  parentShouldBeUndraftedFirst(parentTaskName: string) {
    return i18n.t('parentShouldBeUndraftedFirst', {
      ns: 'taskManager',
      parentTaskName,
    });
  },
  createdByIn(name: string, date: string) {
    return `ساخته شده توسط ${name} در ${date}`;
  },
  from(item: string) {
    return `از ${item}`;
  },
  setTaskStateToReadyPublish(
    readyToPublishTaskTitle: string,
    taskName: string
  ) {
    return i18n.t('changeStateToReadyToPublish', {
      ns: 'taskManager',
      taskName,
      state: this.readyPublishTask(readyToPublishTaskTitle, taskName),
    });
  },
  setTaskStateToReadyPublishSubTasks(
    readyToPublishSubTaskTitle: string,
    taskName: string,
    subTasksTitle: string
  ) {
    return i18n.t('taskStateReadytoPublishSubtasks', {
      ns: 'taskManager',
      taskName,
      subtasks: this.readyPublishSubTask(
        readyToPublishSubTaskTitle,
        this.subtasks(subTasksTitle)
      ),
    });
  },
  otherPersons(number: number) {
    return i18n.t('otherPersons', {
      ns: 'taskManager',
      number: convertDigitToProperFormat(number),
    });
  },
  confirmDeleteAttachment(name: string) {
    return `ایا از حذف ضمیمه «${name}» مطمئن هستید؟`;
  },
  byUser(name: string) {
    return `${name}`;
  },
  taskCloned: 'کپی با موفقیت ایجاد شد و در حال مشاهده آن هستید',
  showParents(taskName: string) {
    return i18n.t('showParents', { ns: 'taskManager', taskName });
  },
  moveTask(taskName: string) {
    return `تغییر مکان ${taskName}`;
  },
  getAssignmentName(name: string, withDash: boolean) {
    return withDash ? addDash(name) : name;
  },
};

const getStatus: { [key: string]: string } = {
  started: 'شروع شده',
  complete: 'تکمیل شده',
  notStarted: 'شروع نشده',
};
